import React, { Fragment } from 'react';
import AutomaticUserAllocationContainer from './AutomaticUserAllocationContainer';
import Header from './header/Header';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_AUTOMATIC_USER_ALLOCATION } from 'constants/rightsCodes';

import { withAreaGetter } from 'providers/AreasConsumers';

const Route = props => {
  const { getElemByAreaKey } = props;
  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_AUTOMATIC_USER_ALLOCATION}>
        <AutomaticUserAllocationContainer />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
